import { earlyFeatureSlice } from './early-feature.slice';

export const { setEarlyFeatureCode } = earlyFeatureSlice.actions;
